import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AccountingClientMonitoring = _resolveComponent("AccountingClientMonitoring")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        style: {"border-radius":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "Data" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Dossiers")
            ])),
            _: 1
          }),
          (_ctx.isAllowedToStatusOfFiles)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 0,
                value: "Monitoring",
                "data-cy": "AccountingClients-etatAvancementDossiers"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Etat d'avancement des dossiers")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_tabs_window, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "Data" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              cols: "12",
              class: "my-2 justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "pl-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.search,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                      label: "Recherche",
                      outlined: "",
                      "hide-details": "",
                      "data-cy": "AccountingClients-search",
                      density: "compact",
                      clearable: "",
                      "append-inner-icon": "$search"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "px-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_data_table, {
                      headers: _ctx.headers,
                      items: _ctx.filteredCompanies,
                      class: "table",
                      striped: true,
                      dense: true,
                      "fixed-header": "",
                      virtualScroll: true,
                      height: "calc(100vh - 176px)"
                    }, {
                      item: _withCtx((props) => [
                        _createElementVNode("tr", {
                          onClick: _withModifiers(($event: any) => (_ctx.openClient(props.item)), ["stop"]),
                          style: {"cursor":"pointer"}
                        }, [
                          _createElementVNode("td", null, _toDisplayString(props.item.legalForm || ""), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.name), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.siret ? props.item.siret.split("_")[0] : ""), 1),
                          _createElementVNode("td", null, [
                            (props.item && props.item.activity)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  location: "bottom"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), _toDisplayString(props.item?.activity || ""), 17)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(props.item.activityDescription), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(props.item.incomeCategory
                                                ? _ctx.$t("settings." + props.item.incomeCategory)
                                                : ""), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.taxRegime
                                                ? _ctx.$t("settings." + props.item.taxRegime)
                                                : ""), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.taxSystemType
                                                ? _ctx.$t("settings." + props.item.taxSystemType)
                                                : ""), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.vatSystem
                                                ? _ctx.$t("settings." + props.item.vatSystem)
                                                : ""), 1)
                        ], 8, _hoisted_3)
                      ]),
                      _: 1
                    }, 8, ["headers", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "Monitoring" }, {
          default: _withCtx(() => [
            _createVNode(_component_AccountingClientMonitoring, { mode: _ctx.mode }, null, 8, ["mode"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}